import React from "react"
import logo1 from "./pic/f_logo.png"
import "./Footer.css"

const Footer = () => {
  return (
    <>
      <footer>
        <div className='conatiner text-center top'>
          <div className='img'>
            {/* <img src={logo1} alt='' /> */}
          </div>
          <p className="footer_p"> Sherzod Tashpolatov ©2022 </p>
          <br/>
        </div>
      </footer>
    </>
  )
}

export default Footer
